import React, { useState } from 'react';
import { useLocale } from '../context/LocaleContext';
import { StepHelpKey } from '../data/stepHelpContent';
import StepHelpPanel from './StepHelpPanel';
import stepStyles from '../styles/stepCommon.module.css';
import styles from '../styles/stepHelpPanel.module.css';

interface StepHelpButtonProps {
  stepKey: StepHelpKey;
  variant?: 'icon' | 'link';
  linkLabel?: string;
  className?: string;
}

const StepHelpButton: React.FC<StepHelpButtonProps> = ({
  stepKey,
  variant = 'icon',
  linkLabel,
  className,
}) => {
  const { t } = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  const resolvedLinkLabel = linkLabel ?? t('step.help.link_default');

  return (
    <>
      {variant === 'icon' ? (
        <button
          type="button"
          className={`${stepStyles.helpBtn} ${className || ''}`}
          onClick={() => setIsOpen(true)}
          title={t('step.help.button_title')}
          aria-label={t('step.help.button_title')}
        >
          ?
        </button>
      ) : (
        <button
          type="button"
          className={`${styles.helpLinkButton} ${className || ''}`}
          onClick={() => setIsOpen(true)}
        >
          {resolvedLinkLabel}
        </button>
      )}
      <StepHelpPanel isOpen={isOpen} onClose={() => setIsOpen(false)} stepKey={stepKey} />
    </>
  );
};

export default StepHelpButton;
